<template>
  <List class="questionnaire-list" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="8">
    <template v-slot:listContent>
      <div class="questionnaire-list-content">
        <el-table :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
          <el-table-column prop="formName" label="问卷名称" min-width="200"> </el-table-column>
          <el-table-column prop="sourceName" label="问卷来源" min-width="200"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="200"> </el-table-column>
          <el-table-column prop="count" label="提交数量" min-width="100"> </el-table-column>
          <el-table-column label="操作" min-width="150">
            <template slot-scope="scope">
              <div class="option-button" @click="openOne(scope.row)">查看问卷数据</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
  </List>
</template>
<script>
import List from '@components/list/listFrame'
import { getFormList } from '@api/questionaire'
import { mapState } from 'vuex'
export default {
  name: 'questionnaireList',
  data() {
    return {
      totalCount: 0,
      currentPageNo: 0,
      tableData: []
    }
  },
  methods: {
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return 'text-align: center'
      }
    },
    //翻页
    flipPage(pageNo) {
      this.getFormList(pageNo)
      this.currentPageNo = pageNo
    },
    getFormList(pageNo) {
      let params = {
        pageNo: pageNo,
        pageSize: 8,
        userName: this.booksCurrentSubAccount !== '' ? this.booksCurrentSubAccount : this.userName
      }
      getFormList(params).then((res) => {
        if (res.status === 200 && res.data) {
          let data = res.data.page
          this.totalCount = data.totalCount
          this.tableData = data.result.map((item) => {
            let time = new Date(item.createTime)
            item.createTime = `${time.getFullYear()}-${this.add0(time.getMonth() + 1)}-${this.add0(time.getDate())} ${this.add0(time.getHours())}:${this.add0(time.getMinutes())}:${this.add0(
              time.getSeconds()
            )}`
            return item
          })
        }
      })
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    openOne(form) {
      this.$emit('updateComponent', { form: form, toWhere: 'detail' })
    }
  },
  computed: {
    ...mapState('manage', ['booksCurrentSubAccount']),
    userName() {
      return localStorage.getItem('username')
    }
  },
  watch: {
    booksCurrentSubAccount() {
      this.getFormList(1)
    }
  },
  mounted() {
    this.getFormList(1)
  },
  components: {
    List
  }
}
</script>
<style lang="scss" scoped>
.questionnaire-list {
  .questionnaire-list-content {
    padding-right: 20px;
  }
  .option-button {
    cursor: pointer;
    color: #df5813;
  }
}
</style>
